/******************************************************************************************
 *	Languages Service
 *******************************************************************************************
 *
 * List of languages available for selection from the language dropdown.
 *
 */
(function() {
  

  // NOTE: If adding a new Language you must do the following:
  // Update Gruntfile copy:buildLocales with the new locale file.
  // Check pluralCat in new locale file.
  // If pluralCat uses either PLURAL_CATEGORY.ZERO or PLURAL_CATEGORY.TWO, 'zero' and/or 'two' will
  // have to be added to every usage of ng-pluralize.

  angular.module('rcLocalization.languages', []).service(
    'Languages',
    /* @ngInject */
    function(_, LANGUAGE_COUNTRY_MAP, locale) {
      this.invertAddress = function() {
        const invertedAddressLocales = ['ja', 'ko', 'zh-cn', 'zh-tw'];
        return _.includes(invertedAddressLocales, locale.getActiveLanguage());
      };
      this.minSearchLength = function() {
        const defaultMinSearchLength = 3;
        const localeMinSearchLengths = {
          ja: 1,
          ko: 1,
          'zh-cn': 1,
          'zh-tw': 1
        };
        return localeMinSearchLengths[locale.getActiveLanguage()] || defaultMinSearchLength;
      };
      //Normalizes language code case and dash by converting to to xx
      this.normalizeLanguageCode = function(languageCode) {
        let normalizedLanguage;
        if (languageCode && _.isString(languageCode)) {
          // Convert underscores to dashes, split on the dash
          // and return the first part (language)
          var parts = _(languageCode)
            .replace('_', '-')
            .split('-');
          if (parts[0]) {
            parts[0] = _.toLower(parts[0]);
          }
          normalizedLanguage = _.toLower(parts[0]);
        }
        return normalizedLanguage;
      };

      //Normalizes language code case and dash by converting to to xx-XX
      this.normalizeLanguageCodeToFourChar = function(languageCode) {
        let normalizedLanguage;
        if (languageCode && _.isString(languageCode)) {
          // Covert underscores to dashes and uppercase the country code
          var parts = _(languageCode)
            .replace('_', '-')
            .split('-');
          if (parts[0]) {
            parts[0] = _.toLower(parts[0]);
          }
          if (parts[1]) {
            parts[1] = _.toLower(parts[1]);
          } else {
            // if there is no second part, we add the country code based on the first part
            const foundCountryCode = LANGUAGE_COUNTRY_MAP[parts[0]];
            if (foundCountryCode) {
              parts.push(_.toUpper(foundCountryCode));
            }
          }
          normalizedLanguage = parts.join('-');
        }
        return normalizedLanguage;
      };

      //Checks if the app supports the passed-in language code
      this.isSupported = function(languageCode) {
        return (
          _.some(locale.getSupportedLanguages(), {value: languageCode}) ||
          _.some(locale.getSupportedLanguages(), {value: this.normalizeLanguageCode(languageCode)})
        );
      };
    }
  );
})();
